module.exports = __webpack_public_path__ + "static/media/applicationLogotypeWhite.a748d21d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicationLogotypeWhite.svg
// module id = 607
// module chunks = 0